import {
  formDataToLocalizedString,
  LocalizedString,
} from '../common/localizedString';
import { MealItemCustomizationRules } from './mealItemCustomization';
import {
  MealItemCustomizationFormData,
  MealItemCustomizationOptionFormData,
} from './mealItemCustomizationFormData';

export interface MealItemCustomizationModel {
  id?: string;
  customerInstruction: LocalizedString;
  internalNote?: LocalizedString;
  rules?: MealItemCustomizationRules;
  options: MealItemCustomizationOptionModel[];
}

export interface MealItemCustomizationOptionModel {
  id?: string;
  name: LocalizedString;
  price: number;
  isAvailable: boolean;
}

export const toMealItemCustomizationModel = (
  formData: MealItemCustomizationFormData
): MealItemCustomizationModel => ({
  customerInstruction: formDataToLocalizedString(formData.customerInstructions),
  internalNote: formData.internalNotes
    ? formDataToLocalizedString(formData.internalNotes)
    : undefined,
  options: [],
});

export const toMealItemCustomizationOptionModel = (
  formData: MealItemCustomizationOptionFormData
): MealItemCustomizationOptionModel => ({
  id: formData.id,
  name: formDataToLocalizedString(formData.names),
  price: formData.price,
  isAvailable: formData.isAvailable,
});
